const onboardingStages = [
    "demographics",
    "areas-of-expertise",
    "treatment-modalities",
    "documents",
    "peer-references",
    "training",
    "work-history",
    "past-hospital-privileges",
    "state-licenses",
    "malpractice-insurance",
    "board-certifications",
    "immunizations",
    "disclosures",
    "signing"
  ];
  
const getOnboardingStages = (preferences) => {
  var stages = onboardingStages;
  if (preferences && !preferences.showTrainingPage) {
    stages = stages.filter((stage) => stage !== "training");
  }
  if (preferences && !preferences.showWorkHistoryPage) {
    stages = stages.filter((stage) => stage !== "work-history");
  }
  if (preferences && !preferences.showPastHospitalPrivilegesPage) {
    stages = stages.filter((stage) => stage !== "past-hospital-privileges");
  }
  if (preferences && !preferences.showImmunizationsPage) {
    stages = stages.filter((stage) => stage !== "immunizations");
  }
  if (preferences && !preferences.showBoardCertificationsPage) {
    stages = stages.filter((stage) => stage !== "board-certifications");
  }
  if (preferences && !preferences.showAreasOfExpertisePage) {
    stages = stages.filter((stage) => stage !== "areas-of-expertise");
  }
  if (preferences && !preferences.showTreatmentModalitiesPage) {
    stages = stages.filter((stage) => stage !== "treatment-modalities");
  }
  if (preferences && !preferences.showDisclosuresPage) {
    stages = stages.filter((stage) => stage !== "disclosures");
  }

  return stages;
}

export default getOnboardingStages;
